'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '../lib/cn';

const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, max = 100, value, ...props }, ref) => {
  const boundedValue = typeof value === 'number' ? Math.min(Math.max(value, 0), max) : value;
  const percent =
    typeof boundedValue === 'number' && max > 0 ? Math.min((boundedValue / max) * 100, 100) : 0;

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', className)}
      max={max}
      value={boundedValue}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="bg-primary h-full w-full flex-1 transition-transform"
        style={{ transform: `translateX(-${String(100 - percent)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
